<template>
    
    <md-card>
          <md-card-header class="md-card-header-icon">
            <!-- <div class="card-icon">
              <md-icon>design_services</md-icon>
            </div> -->
            <h4 class="title" style="text-align:center; font-weight:bold;">
              Service
            </h4>
          </md-card-header>
          <md-card-content>
            <!-- <h4 class="title">
              Service
            </h4> -->
            <autoextra :collection="service" v-slot="{item,last,index}" v-if="service.length != 0">
              <div class="columns" v-if="!last" :class="{last: last}">
                <label class="label">{{last ? 'New ' : ''}}Service {{!last ? index + 1 : ''}}</label>
                <div class="md-layout md-gutter">
                  <input v-model="item.id" :readonly="true" type="hidden"/>

                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Service Name</label>
                      <md-input  v-model="item.name" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-50">
                    <md-field >
                      <label class="label" >Service Code</label>
                      <md-input  v-model="item.code" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-50">
                    <md-field >
                      <label class="label" >LTS</label>
                      <md-input  v-model="item.lts" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-50">
                    <md-field >
                      <label class="label" >Price</label>
                      <md-input  v-model="item.price" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-50">
                    <md-field >
                      <label class="label" >Discount(%)</label>
                      <md-input v-model="item.pkb_service_discount" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Total</label>
                      <md-input  v-model="item.total" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  <div class="md-layout-item md-small-size-100">
                    <md-field >
                      <label class="label" >Remarks</label>
                      <md-input  v-model="item.pkb_service_remark" :readonly="true"/>
                  
                    </md-field>
                  </div>
                  
                </div>            
              </div>
            </autoextra>
         
            
            <div class="md-layout">
               
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label for="total">Total</label>
                    <md-input  v-model="total" name="total" id="total" :readonly="true" />
                  </md-field>
                </div>
                  
                
              </div>
          </md-card-content>
        </md-card>  
        
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import  Autoextra  from 'vue-autoextra';

export default {
  name: "service-part-card",

 
  props: ['services'],
  components: { Autoextra },

  mixins: [formMixin],

  data () {
    return {
      service: [],
      total : 0,
    }
  },
  created() {
          this.onOpen();
      },
   methods:{
    
     async onOpen(){
       //loop data services
       console.log(this.services)
       this.services.forEach((value, index) => {
           
           //set data service dari data services
            this.$set(this.service, index, {
                id : value.id,
                name: '('+value.service_master_code+') '+value.service_master_name,
                pkb_service_master_id : value.pkb_service_master_id,
                code : value.service_master_code,
                lts : value.service_master_lts+' hours',
                price : value.service_category_standard_cost,
                pkb_service_discount : value.pkb_service_discount,
                total : (value.service_category_standard_cost *value.service_master_lts) - ((value.service_category_standard_cost *value.service_master_lts) * value.pkb_service_discount/100),
                pkb_service_remark : value.pkb_service_remark
              });
          });
          this.total =  this.service.reduce( function(cnt,o){ return cnt + o.total; }, 0)
        
      },


    //   async getDataParent(data) {
    //   console.log("ajajajaj")
    //   console.log(data)
    //   this.services.forEach((value, index) => {
    //     this.$set(this.service, index, {
    //       id : value.id,
    //       name: '('+value.service_master_code+') '+value.service_master_name,
    //       pkb_service_master_id : value.pkb_service_master_id,
    //       code : value.service_master_code,
    //       lts : value.service_master_lts+' hours',
    //       price : value.service_category_standard_cost,
    //       total : value.service_category_standard_cost * value.service_master_lts,
    //       pkb_service_remark : value.pkb_service_remark
    //     });
    //   });
        
    //   // var totalService = 0
    //   // var totalPart = 0
    //   // totalService =  this.service.reduce( function(cnt,o){ return cnt + o.total; }, 0)
    //   // totalPart =  this.part.reduce( function(cnt,o){ return cnt + o.total; }, 0)
    //   // console.log(totalService)
    //   // console.log(totalPart)
    //   // this.total = totalService + totalPart
    // },
      
        //fungsi yang di panggil dari parent untuk mendapatkan nilai total
        getData() {
            this.$emit('data', this.total)
        },

        

    },
    mounted() {
        console.log('Component mounted.')
    }
};
</script>

<style>
.columns{
  margin-bottom: 3ex;
  border-bottom: 5px solid black;
}
</style>
